import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function NoMatch() {
	const { t } = useTranslation();
	return <Box>{t('system:titlesNoMatch')}</Box>;
}

export default NoMatch;
